export default {
    layout: {
        loading: 'ကုန်သွယ်မှု ဆောင်ရွက်နေသည်',
        trading: 'ကုန်သွယ်မှု ဆောင်ရွက်နေသည်'
    },
    footer: {
    },
    menu: {
        home: 'ပင်မစာမျက်နှာ',
        staking: 'Matrix',
        port: 'PORT',
        internet: 'ကွန်ယက်',
        me: 'ကျွန်တော်',
    },
    header: {
        selectLang: 'ဘာသာစကားရွေးချယ်ရန်',
        close: 'ပိတ်ရန်',
        trading: 'ကုန်သွယ်မှု',
        dashboard: 'ဒက်ရှ်ဘုတ်',
        subscribeMatrix: 'Matrix စာရင်းသွင်းရန်',
        portTaskCenter: 'PORT အလုပ်အမှုစင်တာ',
        network: 'ကွန်ယက်',
        apiBinding: 'API ချိတ်ဆက်မှု',
        gridTree: 'Grid သစ်ပင်',
        account: 'အကောင့်',
        documents: 'စာရွက်စာတမ်း & Whitepaper',
        personalCenter: 'ပုဂ္ဂိုလ်ရေးစင်တာ',
        language: 'ဘာသာစကား'
    },
    home: {
        recently1:'အသိုင်းအဝိုင်း',
        staticrewares: 'တည်ငြိမ်',
        recentlyName: 'စာရင်း',
        recentlyInfo: 'ဝင်ငွေအသေးစိတ်',
        dataUpdate: 'ဒေတာ အပ်ဒိတ်',
        realtime: 'အချိန်မှန်·BSC',
        totalRevenue: 'စုစုပေါင်းဝင်ငွေ (USDT)',
        today: 'ယနေ့',
        totalTradingVolume: 'စုစုပေါင်း ကုန်သွယ်မှု',
        todayEarn: 'ယနေ့ရရှိမှု',
        share: 'သူငယ်ချင်းများနှင့် မျှဝေပါ',
        shareDesc: 'ဝင်ငွေကို မျှဝေပြီး အကျိုးခံစားခွင့်ရယူပါ',
        directReferrals: 'တိုက်ရိုက်အညွှန်းများ',
        teamMembers: 'အသင်းအဖွဲ့ အဖွဲ့ဝင်များ',
        thisWeek: 'ယခုအပတ်',
        copy: 'မိတ္တူကူး',
        recently: 'မကြာသေးမီ ဝင်ငွေ',
        netIncome: 'အမြတ်အစွန်း',
        dailyAverage: 'နေ့စဉ် ပျမ်းမျှ',
        quantitativeIncome: 'ပမာဏအခြေခံ ဝင်ငွေ',
        recommend: 'အကြံပြု',
        port: 'PORT',
        bonus: 'ဆုကြေး',
        all: 'အားလုံး',
        todayTitle: 'ယနေ့',
        loadingMore: 'နောက်ထပ် တင်နေသည်',
        recommendBonus: 'အကြံပြု ဆုကြေး',
        portTaskPassed: 'PORT အလုပ်အမှု အောင်မြင်',
        myProfit: 'ကျွန်တော်၏ အမြတ်',
        earningOnBitDeep: 'BitDeep တွင် ဝင်ငွေ ရယူနေသည်',
        totalRevenueUsdt: 'စုစုပေါင်း ဝင်ငွေ · USDT',
        consecutiveDays: 'ဆက်တိုက် နေ့ရက်များ',
        scanToJoin: 'Scan လုပ်ပြီး ဝင်ပါ',
        uid: 'UID',
        referralBonus: 'အညွှန်း ဆုကြေး',
        shareTo: 'မျှဝေသို့',
        eachReferral: 'မျှဝေ ဆုကြေး',
        screenshotAndShare: 'Screenshot လုပ်ပြီး မျှဝေပါ',
        saveShareEarn: 'သိမ်းဆည်း · မျှဝေ · ဆုကြေးရယူ',
        period: 'ကာလ',
        netProfit: 'အမြတ်အစွန်း',
        quantReward: 'ပမာဏ ဆုကြေး',
        dailyBonus: 'PORT နေ့စဉ် ဆုကြေး',
        close: 'ပိတ်ရန်',
        permission: 'ခွင့်ပြုချက်',
        onlyEnable: 'ဖွင့်ထားသည့်အရာသာ',
        enterBitgetUid: 'BITGET UID ထည့်ပါ',
        slogan: 'စကားပုံ',
        document: 'စာရွက်စာတမ်း',
        days: 'နေ့',
        taskText: 'အလုပ်',
        minutes: 'မိနစ်',
        decentralizedPortTech: 'Decentralized PoRT နည်းပညာဖွဲ့စည်းပုံ၊ BGB Token စီးပွားရေး၊ နှစ်ခုအကျိုးခံစားခွင့် Matrix။',
        auditReport: 'စစ်ဆေးမှု အစီရင်ခံစာ',
        faqSupport: 'မေးလေ့ရှိသောမေးခွန်းများ & အထောက်အပံ့',
        telegram: 'Telegram',
        piece: 'အပိုင်း',
        faq: 'မေးလေ့ရှိသောမေးခွန်းများ',
       faq1: 'Bitget API ကို ဘယ်လို ချိတ်ဆက်ရမလဲ?',
        faq1Desc: 'Bitget Exchange → Settings → API Management သို့ဝင်ပြီး API Key နှင့် Secret ရယူပါ။ Spot Trading ခွင့်ပြုချက်ကိုသာ ဖွင့်ပါ; ထုတ်ယူခွင့်ပြုချက်ကို လုံးဝမဖွင့်ပါနှင့်။ keys များကို BitDeep DApp တွင် ပွတ်ဆွဲထည့်ပါ။ 1 USDT စမ်းသပ်အရောင်းအဝယ်ပြီးပါက ချိတ်ဆက်မှု အသုံးပြုနိုင်ပါပြီ။',
        faq2: 'PoRT (အစစ်အမှန် အရောင်းအဝယ်သက်သေ) ဆိုတာ ဘာလဲ?',
        faq2Desc: 'PoRT သည် "ကုန်သွယ်ခြင်း = တူးဖော်ခြင်း" ၏ အဓိကယန္တရားဖြစ်သည်။ စနစ်သည် နေ့စဉ် Bitget API မှ သတ်မှတ်ထားသော coin (ဥပမာ BGB) တွင် မြန်ဆန်စွာ ဝယ်ရောင်းခြင်းကို အလိုအလျောက် လုပ်ဆောင်သည်။ ကုန်သွယ်မှု ပမာဏသည် Stake × 50% ထက်ကျော်လွန်ပါက စနစ်က အတည်ပြုပြီး နေ့စဉ်ဆုလာဘ်ထုတ်ပေးသည်။',
        faq3: 'နေ့စဉ် ကိုယ်တိုင် စောင့်ကြည့်ဖို့ လိုပါသလား?',
        faq3Desc: 'မလိုပါ။ API ချိတ်ဆက်ပြီးနောက် စနစ်က 24 နာရီ ဝင်းဒိုးအတွင်း အရောင်းအဝယ်တာဝန်ကို အလိုအလျောက် ပြီးစီးစေသည်။ ကိုယ်တိုင်လုပ်စရာမလို; PoRT မီနူးတွင် စစ်ဆေးနိုင်သည်။',
        faq4: 'ALPHA နှင့် SIGMA ဘာတွေ ကွာခြားသလဲ?',
        faq4Desc: 'ALPHA (Starter): 500 USDT stake, နေ့စဉ်အကျိုးအမြတ် 0.3–1.3%, 1 ပက်ကေ့ချ်သာ။ SIGMA (Pro): 1,000 USDT stake, နေ့စဉ်အကျိုးအမြတ် 0.6–1.6%, အများဆုံး 5 ပက်ကေ့ချ်။',
        faq5: 'ကျွန်ုပ်၏ ငွေသည် လုံခြုံပါသလား? ပလက်ဖောင်းက ကျွန်ုပ်၏ ငွေကို ထိနိုင်ပါသလား?',
        faq5Desc: 'သင်၏ ငွေသည် 100% သင်၏ Bitget အကောင့်တွင်သာ ရှိနေသည်။ API သည် read နှင့် spot trading ခွင့်ပြုချက်များကိုသာ ပေးပြီး; စနစ်က မူရင်းငွေ မည်သည့်အရာကိုမှ ထုတ်ယူ၊ လွှဲပြောင်းနိုင်ခြင်း မရှိပါ။',
        faq6: 'နေ့စဉ်ဝင်ငွေကို ဘယ်အချိန် ရှင်းပေးပါသလဲ?',
        faq6Desc: 'PoRT အတည်ပြုပြီးနောက် နောက်တနေ့ ရှင်းပေးပါသည်။ စနစ်က USDT ဝင်ငွေ နှင့် 10x Deep အမှတ်များ ဆုလာဘ်နှစ်ဆ ကို အလိုအလျောက် ထုတ်ပေးပါသည်။',
        faq7: 'Scout Bonus (တိုက်ရိုက်အကြံပြုဆုလာဘ်) ကို ဘယ်လို တွက်ချက်ပါသနည်း?',
        faq7Desc: 'သင်တိုက်ရိုက်ညွှန်းသော အသက်ဝင်အကောင့်တစ်ခုစီအတွက် နေ့စဉ်သတ်မှတ်ဆုလာဘ်ရရှိမည် — ALPHA (500 USDT) အကောင့်ညွှန်းပါက 1 USDT/နေ့, SIGMA (1,000 USDT) အကောင့်ညွှန်းပါက 2 USDT/နေ့, ထိုအကောင့်၏ သက်တမ်းကုန်ဆုံးသည်အထိ ပေးပါမည်။',
        faq8: 'အဆင့် (D1–D7) ကို ဘယ်လို တိုးတက်စေသနည်း?',
        faq8Desc: 'ဇုန်ငယ်စုစုပေါင်းပမာဏပေါ်အခြေခံ၍ အဆင့်တိုးတက်ပါ။ ဥပမာ — D1 အတွက် 2,000 USDT, D3 အတွက် 15,000 USDT, အမြင့်ဆုံး D7 အတွက် 3,000,000 USDT လိုအပ်သည်။ အဆင့်မြင့်လေ၊ အဆင့်ခြားနားမှု ဆုလာဘ်များ ပိုကောင်းလေ (D7 အမြင့်ဆုံး 7 USDT/ဦး/နေ့)။',
        faq9: 'တစ်လှည့်သည် ဘယ်နှစ်ရက်ရှိသနည်း? သက်တမ်းကုန်ဆုံးပြီး ဘယ်လို ဆက်လုပ်မလဲ?',
        faq9Desc: 'လှည့်တစ်ခုသည် 28 ရက်ဖြစ်သည်။ လှည့်ပြီးဆုံးပြီးနောက် stake ဆက်လုပ်ရန် ရွေးချယ်နိုင်ပါသည်; ဆုလာဘ်များကို နေ့စဉ်အမှန်တကယ် PoRT အတည်ပြုရလဒ်အပေါ် မူတည်၍ ပြောင်းလဲသော အကျိုးအမြတ်ဖြင့် ပေးပါသည်။',
        faq10: 'ထုတ်ယူခြင်းအတွက် အခကြေးငွေ ရှိသလား?',
        faq10Desc:'ထုတ်ယူခြင်းသည် ဝန်ဆောင်ခ 0 ဖြစ်သည်။ ပလက်ဖောင်းသည် ထုတ်ယူခများကို pool သို့ ပြန်လည်ဖြည့်တင်းပြီး LP liquidity ကို တိုးတက်စေကာ ကောင်းမွန်သော သံသရာဖြစ်ပေါ်စေသည်။',
        bigArea: 'ဧရိယာကြီး',
        smallArea: 'ဧရိယာသေး',
        enterWithdrawAmount: 'ထုတ်ယူမည့် ပမာဏ ထည့်ပါ',
        all: 'အားလုံး',
        available: 'အသုံးပြုနိုင်သည်',
        totalAmount: 'စုစုပေါင်း ပမာဏ',
        confirmWithdraw: 'ထုတ်ယူမှု အတည်ပြု',
        withdrawRecord: 'ထုတ်ယူမှု မှတ်တမ်း',
        withdrawn: 'ထုတ်ယူပြီး',
        quickStartGuide:'စတင်ရန် လမ်းညွှန်',
        whitepaperGuide:'Whitepaper & လမ်းညွှန်',
        whitepaper:'Whitepaper',
        downloadPdf:'ဒေါင်းလုဒ်'
    },
   staking: {
    selectPackage: 'Matrix စာရင်းသွင်းရန်',
    alpha: 'ALPHA',
    beginner: 'စတင်',
    sigma: 'SIGMA',
    professional: 'ပရော်ဖက်ရှင်နယ်',
    popular: 'အများဆုံး လူကြိုက်',
    dailyReturn: 'နေ့စဉ် အကျိုးအမြတ်',
    teamDepth: 'အသင်း အနက်အမြဲ',
    limitPurchase: 'ဝယ်ယူမှု ကန့်သတ်',
    layer: 'အလွှာ',
    copy: 'အပိုင်း',
    autoRenew: 'အလိုအလျောက် တိုးချဲ့',
    autoReinvest: 'အလိုအလျောက် ပြန်လည်ရင်းနှီးမြှုပ်နှံ',
    subscribeAlpha: 'Alpha စာရင်းသွင်းရန်',
    subscribeSigma: 'Sigma စာရင်းသွင်းရန်',
    stakedAmount: 'Staking ပမာဏ',
    stakedAmount2: 'ကာလ',
    stakedAmount3: 'စုဆောင်း ဝင်ငွေ',
    stakingTime: 'Staking အချိန်',
    maturityTime: 'သက်တမ်းကုန် အချိန်',
    redeem: 'ပြန်ထုတ်',
    renew: 'တိုးချဲ့',
    autoRenewActive: 'အလိုအလျောက် တိုးချဲ့ပြီး',
    autoRenewInactive: 'အလိုအလျောက် မတိုးချဲ့',
    smartContract: 'Smart Contract ထိန်းသိမ်းမှု၊ အလုပ်ငွေကို 28 ရက် ကာလအတွင်း လော့ခ်ထားပြီး သက်တမ်းကုန်ချိန်တွင် ဖြေရှင်းမည်။',
},
me: {
    account: 'အကောင့်',
    my: 'ကျွန်တော်',
    staked: 'Staking ပြီး',
    points: 'အမှတ်',
    consecutive: 'ဆက်တိုက် နေ့ရက်',
    withdraw: 'ထုတ်ယူ',
    language: 'ဘာသာစကား',
    simplifiedChinese: 'ရိုးရှင်းသော တရုတ်',
    disconnectWallet: 'ပိုက်ဆံအိတ် ချိတ်ဆက်မှု ဖြုတ်ရန်',
    level: 'အဆင့်',
    joinDate: 'ဝင်ရောက် သည့်နေ့',
    bdId: 'BD-ID'
},
bindapi: {
    apiBinding: 'API ချိတ်ဆက်မှု',
    bindDesc: 'သင့် Exchange API key ကို ချိတ်ဆက်ပြီး Quant Trading အတွက် ခွင့်ပြုပါ',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    exchange: 'Exchange',
    futures: 'စာချုပ်',
    spot: 'Spot',
    readOnly: 'ဖတ်ရန်သာ',
    bind: 'ချိတ်ဆက်',
    riskNote: 'API Key သည် Trading Data Sync အတွက်သာ အသုံးပြုသည်၊ အချက်အလက် အနူးအညွတ် မသိမ်းဆည်းပါ',
    apiConnection: 'API ချိတ်ဆက်မှု',
    bindExchangeApi: 'Exchange API ချိတ်ဆက်ရန်',
    bitDeepRead: 'BitDeep သည် သင့် CEX အကောင့်မှ Order Flow ကို ဖတ်ပြီး အမှန်တကယ် ကုန်သွယ်မှု အထောက်အထား (PoRT) ကို အတည်ပြုသည်။',
    noWithdraw: 'ကျွန်တော်တို့ သင့် Withdraw ကို မထိမချ။',
    securityTip: 'လုံခြုံရေး အကြံပြုချက် · ဂရုပြုဖတ်ပါ',
    close: 'ပိတ်ရန်',
    withdraw: 'ထုတ်ယူ',
    permission: 'ခွင့်ပြုချက်',
    onlyEnable: 'ဖွင့်ထားသည့်အရာသာ',
    spotTrading: 'Spot Trading',
    read: 'ဖတ်ရန်',
    recommendedPartner: 'အကြံပြု မိတ်ဖက်',
    zeroFee: '0% ကုန်ကျစရိတ်',
    activated: 'အသုံးပြုထားပြီး',
    classicAccount: 'Classic အကောင့်',
    unifiedAccount: 'Unified အကောင့်',
    bindBitgetApi: 'Bitget API ချိတ်ဆက်ရန်',
    upcoming: 'မကြာမီ ထွက်မည်',
    underAudit: 'အဆက်အသွယ် စစ်ဆေးနေသည်',
    expected: 'မျှော်လင့်ထားသည်'
},
port: {
    portTaskCenter: 'PORT အလုပ်အမှုစင်တာ',
    dailyTask: 'နေ့စဉ် အလုပ်',
    verify: 'အတည်ပြု',
    completed: 'ပြီးစီးပြီး',
    incomplete: 'မပြီးစီး',
    verifyStandard: 'အတည်ပြု စံချိန်စံညွှန်း',
    tradingVolume: 'ကုန်သွယ်မှု ပမာဏ',
    today: 'ယနေ့',
    deadline: 'သတ်မှတ်ထားသော အချိန်',
    reward: 'ဆုကြေး',
    startVerify: 'အတည်ပြုမှု စတင်ရန်',
    verifying: 'အတည်ပြုနေသည်',
    verified: 'အတည်ပြုပြီး',
    insufficient: 'မလုံလောက်',
    viewDetails: 'အသေးစိတ် ကြည့်ရန်',
    taskList: 'အလုပ်စာရင်း',
    allTasks: 'အလုပ်အားလုံး',
    completedTasks: 'ပြီးစီးပြီး',
    pendingTasks: 'မပြီးစီး',
    proofOfRealTrading: 'အမှန်တကယ် ကုန်သွယ်မှု အထောက်အထား',
    todayTask: 'ယနေ့ အလုပ်',
    todayStaticIncome: 'ယနေ့ တည်ငြိမ် ဝင်ငွေ',
    points: 'အမှတ်',
    todayWindowClosesAt: 'ယနေ့ Window ပိတ်ချိန်',
    checkTaskStatus: 'အလုပ် အခြေအနေ စစ်ဆေးရန်',
    teamProgress: 'အသင်း တိုးတက်မှု · ယနေ့',
    realtimePortCompletion: 'အချိန်မှန် PORT အပြီးစီးမှု',
    completedText: 'ပြီးစီးပြီး',
    pendingText: 'မပြီးစီး',
    realtimeApiValidationFlow: 'အချိန်မှန် · API · အတည်ပြု စီးဆင်းမှု',
    rewardRemark1:'Global Dividend',
        rewardRemark2:'Level-Differential Bonus',
        rewardRemark3:'Scout Bonus',
        rewardRemark4:'Task Reward',
        rewardRemark5:'PoRT Task Success',
},
internet: {
    network: 'ကွန်ယက်',
    treeBrowser: 'Tree Browser',
    searchAddress: '0x... လိပ်စာ သို့မဟုတ် BD-ID ရှာရန်',
    totalTradingVolume: 'စုစုပေါင်း ကုန်သွယ်မှု',
    members: 'အသင်းဝင်များ',
    networkStructure: 'ကွန်ယက် ဖွဲ့စည်းပုံ',
    allLevels: 'အဆင့်အားလုံး',
    addRemark: 'မှတ်ချက် ထည့်ရန်',
    enterRemark: 'မှတ်ချက် ထည့်ပါ',
    cancel: 'မလုပ်တော့',
    confirm: 'အတည်ပြု'
},
withdraw: {
    withdraw: 'ထုတ်ယူ',
    usdtAsset: 'USDT ပိုင်ဆိုင်မှု',
    withdrawAmount: 'ထုတ်ယူ ပမာဏ',
    availableBalance: 'အသုံးပြုနိုင်သော လက်ကျန်',
    fee: 'ကုန်ကျစရိတ်',
    actualArrival: 'အမှန်တကယ် ရောက်ရှိမှု',
    submit: 'တင်သွင်းရန်',
    withdrawSuccess: 'ထုတ်ယူမှု အောင်မြင်',
    withdrawFailed: 'ထုတ်ယူမှု မအောင်မြင်',
    processing: 'ဆောင်ရွက်နေသည်',
    completed: 'ပြီးစီးပြီး',
    withdrawHistory: 'ထုတ်ယူ မှတ်တမ်း'
},
popup: {
    taskUnfinished: 'အလုပ် မပြီးစီး',
    taskUnfinishedDesc: 'ယနေ့ PoRT အတည်ပြု စံချိန် မပြည့်မီ',
    todayTradingVolume: 'ယနေ့ ကုန်သွယ်မှု ပမာဏ',
    remaining: 'ကျန်ရှိ',
    toComplete: 'ပြီးစီးရန် လိုအပ်သည်',
    tradingVolumeThreshold: '',
    deadline: 'အလုပ် သတ်မှတ်ချိန် ကျန်ရှိ',
    tryAgain: 'နောက်မှ ထပ်ကြိုးစားပါ',
    goTrade: 'ကုန်သွယ်ရန်',
    taskCompleted: 'အလုပ် အတည်ပြုပြီး',
    taskCompletedDesc: 'ယနေ့ PoRT ကုန်သွယ်မှု အထောက်အထား Blockchain တွင် အောင်မြင်စွာ တင်သွင်းပြီး',
    rewardIssued: 'ဆုကြေး ထုတ်ပေးပြီး',
    complete: 'ပြီးစီး',
    shareTitle: 'ဖိတ်ကြား မျှဝေ',
    shareDesc: 'သူငယ်ချင်းများကို ဖိတ်ကြားပါ၊ နှစ်ဖက်စလုံး ဆုကြေး ရရှိမည်',
    referralLink: 'ဖိတ်ကြား လင့်',
    qrCode: 'QR ကုဒ်',
    copyLink: 'လင့် မိတ္တူကူး'
}

};
